import Delegate from 'ftdomdelegate'

import Carousel from '../components/carousel'
import nodeListToArray from '../tools/nodeListToArray';

export default class VideoSection {
  constructor(container) {
    this.element = container;
    this.domDelegate = new Delegate(this.element)
    this.videoItems = nodeListToArray(this.element.querySelectorAll('[data-action="play-video"]'))
    this.elementToInsert = null
    this.players = {}
    this.options = {}
    this.isSwiping = false;

    this.videoSlideshowElement = this.element.querySelector('.video-list[data-flickity-config]')
    if(this.videoSlideshowElement) {
      this.videoSlideshow = new Carousel(this.videoSlideshowElement)
    }
    this._attachListeners()
  }

  _setOptions(event, target) {
    this.videoItem = target
    this.elementToInsert = this.videoItem.querySelector('.videoHolder')
    this.options = JSON.parse(this.videoItem.getAttribute('data-videos-settings'));
    this.videoItem.classList.add('is-playing');
    this._loadScript().then(this._setupPlayer.bind(this))
  }
  _loadScript(event, target) {
    var _this27 = this;

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = _this27.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }
  onUnload() {
    if (this.player) {
      this.player.destroy(); // Both YouTube and Vimeo use the same function name
    }
  }
  _attachListeners() {
    let _this1 = this
    
    _this1.domDelegate.on('mousedown', '[data-action="play-video"]', (event) => {
      this.isSwiping = false;
    });

    _this1.domDelegate.on('mousemove', '[data-action="play-video"]', () => {
      this.isSwiping = true;
    });

    _this1.domDelegate.on('mouseup', '[data-action="play-video"]', (event, target) => {
      if (!(this.isSwiping && event.button === 0)) {
        // not dragging
        _this1._setOptions(event, target);
      }

      this.isSwiping = false;
    });

    _this1.domDelegate.on('touchstart', '[data-action="play-video"]', () => {
      this.isSwiping = false;
    });

    _this1.domDelegate.on('touchmove', '[data-action="play-video"]', () => {
      this.isSwiping = true;
    });

    _this1.domDelegate.on('touchend', '[data-action="play-video"]', (event, target) => {
      event.preventDefault();

      if (!this.isSwiping) {
        // Not swiping
        _this1._setOptions(event, target);
      }

      this.isSwiping = false;
    });

    this.videoSlideshow.flickityInstance.on('staticClick', function( event, pointer, cellElement, cellIndex ) {
      if ( !cellElement ) {
        return;
      }
      _this1._setOptions(event, cellElement)
    });

  }
  _setupPlayer() {
    var _this28 = this;
    var currentIndex = this.videoItems.indexOf(_this28.videoItem)
    var eventListenersTriggered = true
    var playerLoadingInterval = setInterval(function () {
      if (_this28.options['videoType'] === 'youtube') {
        if (window.YT) {
          window.YT.ready(function() {
            new YT.Player(_this28.elementToInsert, {
              videoId: _this28.options['videoId'],
              playerVars: {
                showinfo: 0,
                controls: 0,
                fs: 1,
                rel: 0,
                height: '100%',
                width: '100%',
                iv_load_policy: 3,
                html5: 1,
                loop: 0,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
                origin: _this28.options['requestHost']
              },
              events: {
                onReady: (event) => {
                  _this28.players["player" + currentIndex] = event.target
                  // this.player.mute();
                  if(eventListenersTriggered) {
                    _this28.players["player" + currentIndex].playVideo();
                    eventListenersTriggered = false;
                  }
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    _this28.videoItem.classList.remove('is-playing')
                  }
                  if (event.data === YT.PlayerState.PLAYING) {
                    _this28.videoItem.classList.add('is-playing')
                  }
                }
              }
            });
            clearInterval(playerLoadingInterval);
          })
        }
      } else {
        // if (window.Vimeo) {
        //   _this28.player = new Vimeo.Player(_this28.elementToInsert, {
        //     id: _this28.options['videoId'],
        //     autoplay: true,
        //     muted: false,
        //     background: true,
        //     /*height: '100%',
        //     width: '100%',*/
        //     loop: true
        //   });
        // }
      }
    }, 50);
    if(_this28.players["player" + currentIndex] !== undefined) {
      _this28.players["player" + currentIndex].playVideo();
      // if(_this28.player.getPlayerState() === 1 ) {
      //   _this28.videoItem.classList.remove('is-playing')
      //   _this28.player.pauseVideo();
      // }
    }
  }
}